import { render, staticRenderFns } from "./customerCustomFields.vue?vue&type=template&id=c55a27b4"
import script from "./customerCustomFields.ts?vue&type=script&lang=js&external"
export * from "./customerCustomFields.ts?vue&type=script&lang=js&external"
import style0 from "./customerCustomFields.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports